<template>
	<div id="home">
		<NavBar :type="navType"></NavBar>
		<div class="head-swiper">
			<home-swiper :cbanners="banners" @swiperImageLoad="swiperImageLoad"></home-swiper>
			<swiper-bottom></swiper-bottom>
		</div>
		
		<!--产品列表-->
		<div id="product" class="project-block">
			<div class="pro-blo-title wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">产品中心</div>
			<product-list :data="productList"></product-list>
		</div>
		
		<!--合作伙伴-->
		<div class="gray-bg" id="cooperpartner">
			<div class="project-block ">
				<div class="pro-blo-title wow fadeInUp mb-60" data-wow-duration="1.3s" data-wow-delay="0.2s">合作伙伴</div>
				<cooper-partner type="1"></cooper-partner>
			</div>
		</div>
		
		
		<!--底部-->
		<home-footer></home-footer>
		
	</div>
</template>

<script>
	
	import NavBar from "@/components/common/navbar/NavBar.vue";
	import HomeSwiper from "@/views/home/childComps/HomeSwiper";
	import SwiperBottom from "@/components/content/swiperbottom/SwiperBottom";
	import ProductList from "@/components/content/productlist/ProductList";
	import CooperPartner from '@/components/content/cooperpartner/CooperPartner'
	import HomeFooter from '@/components/common/homefooter/HomeFooter'
	
	
	// import {getHomeMultidata,getHomeGoods} from "@/network/home";
	

	export default {
		name: "Home",
		components: {
			NavBar,
			HomeSwiper,
			SwiperBottom,
			ProductList,
			CooperPartner,
			HomeFooter,
		},
		data() {
			return {
				banners: [{
					image:require('@/assets/img/home/slider-1.png'),
					content:'智慧校园行业解决方案'
				}/* ,{
					image:require('@/assets/img/home/slider-2.jpg'),
					content:'智慧校园行业解决方案'
				},{
					image:require('@/assets/img/home/slider-3.jpg'),
					content:'智慧校园行业解决方案'
				} */],
				recommends: [],
				isShowBacktop: false,
				tabOffsetTop: 0,
				isTabFixed: false,
				
				productList:[{
					id: 0,
					img: require('@/assets/img/home/pro-list1.png'),
					title:'智慧食堂',
					contents:['基于支付宝人脸识别技术，实现食堂无卡消费','集管理、智能硬件、移动支付于一体','家长实时把握学生在校消费',
					'窗口一键结账，方便快捷','管理者实时把握费用数据']
				},{
					id: 7,
					img: require('@/assets/img/home/pro-list2.png'),
					title:'家校视讯',
					contents:['以校园公用的可视电话为硬件载体，融合人脸识别技术搭建家校云平台','调用主流平台媒体核心技术，实现亲情音视频通话刚性需求解决K12阶段家校通痛点']
				},{
					id: 3,
					img: require('@/assets/img/home/pro-list3.png'),
					title:'智慧门禁',
					contents:['基于人脸识别技术，以“云+端”的服务方式，实时记录保存与上传，打造学生宿舍安全管理、人脸识别访客管理系统、智能通道系统、智能门禁系统、智能考勤系统、视频动态及检索系统（抓拍、监控、报警、检索等）']
				},{
					id: 5,
					img: require('@/assets/img/home/pro-list4.png'),
					title:'互联网+明厨亮灶',
					contents:['迅速建立起科学高效的监督管理体系','实现食堂各个环节实时监管、食品溯源','大数据可视化实时监视功能','食品安全管理、追责','餐厅管理全覆盖']
					
				}],
				
				navType:1,
			}
		},
		computed: {

		},
		created() {

		},
		mounted() {
			window.addEventListener('scroll',this.pageScrollFun)
		},
		methods: {
			//切换导航样式
			pageScrollFun(){
				var top = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset;
				// console.log('offset:',top);
				//一屏高度
				// console.log(window.innerHeight)
				
				let browserHeight = window.innerHeight;
				
				if(top>browserHeight-400){//滚动高度超出 一屏 高度
					this.navType = 2;
				}else{
					this.navType = 1;
				}
			},
			swiperImageLoad(){
			  /* 获取tabScrollTop */
			  // console.log();
			  // this.tabOffsetTop = this.$refs.tabControl2.$el.offsetTop;
			},
			
			backTopClick() {
				this.$refs.scroll.gotoScroll(0, 0, 500);
			},
			contentScroll(position) {
				// console.log(position);
				this.isShowBacktop = (-position.y) > 1000;
				/* tabControl 吸顶效果 */
				this.isTabFixed = (-position.y) > this.tabOffsetTop;
			},
			loadMore() {
				// this.getHomeGoods(this.currentType);
			},
		},
		deactivated() {}
	}
</script>

<style scoped>
	#home {
		/* overflow-y: scroll; */
	}

	.head-swiper{
		height: 100vh;
		position: relative;
	}
	
	
	.project-block{
		width: 1200px;
		height: auto;
		margin: 0 auto;
		padding: 78px 0;
	}
	.pro-blo-title{
		font-size: 44px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #333333;
		text-align: center;
		margin-bottom: 120px;
		position: relative;
	}
	.pro-blo-title::before{
		position: absolute;
		bottom: -10px;
		left: 50%;
		margin-left: -17px;
		content: '';
		width: 34px;
		height: 2px;
		background: #E89214;
		border-radius: 1px;
	}
	
	.gray-bg{
		background: #F6F8FA;
	}
	.mb-60{
		margin-bottom: 60px;
	}
	
	@media only screen and (min-width:992px) and (max-width:1199px) {
		
		.project-block{
			width: 100%;
		}
	}
	@media only screen and (min-width:768px) and (max-width:991px) {
		
		.project-block{
			width: 100%;
		}
	}
	@media (max-width:767px) {
		
		.head-swiper{
			height: 580px;
			position: relative;
		}
		.project-block{
			width: 100%;
			padding:40px 0;
		}
		.pro-blo-title{
			margin-bottom: 40px !important;
		}
		#cooperpartner{
			background: #fff;
		}
		#cooperpartner .project-block{
			padding-top: 0;
		}
	}
</style>
